import {useState} from 'react'
import StockUploadList from './StockUploadList';
import StockUpload from './StockUpload';

const Stock = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <StockUpload addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <StockUploadList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default Stock